module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kFm7f"))).then(() => parcelRequire('1iHdE'));